import './Loader.scss';
import loader from '../../assets/img/loading.png'

function Loader() {
  return (
    <div className="Loader">
      <img className="loader-img" alt="loader" src={loader}/>
    </div>
  );
}

export default Loader;
